import React from 'react';
import PropTypes from 'prop-types';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import ListItem2 from 'Components/ComponentLibrary/Components/ListItems/ListItem2';
import ListItemText1 from 'Components/ComponentLibrary/Components/Uncategorized/ListItemText/ListItemText1';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import CheckCircleRounded from '@material-ui/icons/CheckCircleRounded';
import Icon from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Icon';
import AvatarPicker from 'Views/Onboarding/Pages/Survey/SurveyStep/Components/DetailListItem/AvatarPicker';
import DeleteButtonWithConfirmation from 'Components/ComponentLibrary/Components/Buttons/DeleteButtonWithConfirmation';
import { makeStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    padding: theme.spacing(2, 3),
  },
  primaryText: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  secondaryText: {},
}));

const DetailListItem = ({
  onClick,
  onDelete,
  resource,
}) => {
  const classes = useStyles();
  const isComplete = resource.attr('isComplete') === 'true';
  const isPending = resource.attr('isPending') === 'true';

  function handleClick() {
    if (onClick) onClick();
  }

  let color = isComplete ? 'accentBlue20' : 'lightGray5';
  if (isPending) {
    color = 'accentYellow1';
  }

  const hasCheckMarkIcon = resource.attr('hasCheckmarkIcon') && resource.attr('hasCheckmarkIcon') === 'true';

  const iconColor = hasCheckMarkIcon ? 'accentGreen' : 'primary';

  return (
    <ListItem2
      className={classes.root}
      color={color}
      onClick={handleClick}
      button={!!onClick && !hasCheckMarkIcon}
    >
      <AvatarPicker
        className={classes.avatar}
        resource={resource}
      />
      <ListItemText1
        disableTypography
        primary={
          <Typography
            className={classes.primaryText}
            variant={'h3'}
            weight={'bold'}
            color={isPending ? 'black' : 'primary'}
            test={'detail-list-item-primary-text'}
          >
            {resource.attr('primaryText')}
          </Typography>
        }
        secondary={
          <Typography
            className={classes.secondaryText}
            variant={'body1'}
            weight={'medium'}
            color="primaryGray"
            test={'detail-list-item-secondary-text'}
          >
            {resource.attr('secondaryText')}
          </Typography>
        }
      />
      {onDelete ? (
        <DeleteButtonWithConfirmation
          onDelete={onDelete}
          dialogProps={{
            title: 'Are you sure?',
            message: 'Would you like to permanently delete this item?',
            cancelLabel: 'Cancel',
            confirmLabel: 'Delete',
          }}
        />
      ) : null}
      {(resource.link('next') || onClick) ? (
        <Icon
          stroke={iconColor}
          fill={iconColor}
          icon={hasCheckMarkIcon ? CheckCircleRounded : KeyboardArrowRightIcon}
        />
      ) : null}
    </ListItem2>
  );
};

DetailListItem.defaultProps = {
  onClick: undefined,
  onDelete: undefined,
};

DetailListItem.propTypes = {
  onClick: PropTypes.func,
  onDelete: PropTypes.func,
  resource: PropTypes.object.isRequired,
};

export default DetailListItem;
